import i18n from "src/locales/i18n";

function SaleItem(props: any) {
  // const { user } = AppStateHandler.getState();
  const { setPostData, setModalVisibility, setDetailView, ...item } = props;
  const { images, title, sale_price } = item;
  const imgUrl = images.length ? images[0].url : "";
  const detailViewHandler = () => {
    setPostData(item);
    setDetailView(true);
  };

  return (
    <div className="col-md-4" onClick={detailViewHandler}>
      <div className="col_selector">
        <div className={`furniture_card ${i18n.dir()==='rtl'?'text-right':''}`}>
          <img src={imgUrl} className="img-fluid w-100" alt="" />
          <h3 className="fz14 poppinsbold mb-0 pt-2 px-2">
            {sale_price === 0 ? "Free" : `DZD ${sale_price}`}
          </h3>
          <p className={`fz12 mb-0 px-2 pb-3 text-break ${i18n.dir() === 'rtl' ? 'Almaraisemibold':'poppinsregular'}`}>
            {title}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SaleItem;
